export const customerApprovalStatusMessages = {
  Approved: "Customer Approval Received",
  Pending: "Customer is yet to give the approval",
  Declined: "Customer Approval Not Received",
};

export const fileUploadProps = {
  maxFileCount: 1,
  defaultSheetStatus: "Pending",
  fileUploadSuccessMessage: "Upload Completed!",
  PROGRESS_COLOR: "#87d068",
  fileSizeWarning: "Max file size is 10MB",
};

export const CustomerApprovalConstants = {
  HEADER: "Customer Approval Not Received",
  OR_TEXT: "or",
  UPLOAD_TEXT: "Manually Upload Customer Approval",
};
